import { render, staticRenderFns } from "./TicketBlockMembership.vue?vue&type=template&id=198e02fa"
import script from "./TicketBlockMembership.vue?vue&type=script&lang=js"
export * from "./TicketBlockMembership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports